var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ValidatorConstraint } from "class-validator";
export const IDP_ISSUER_REQUIREMENTS = "https URL with no query or fragment (e.g., https://idp.example.com)";
function isLocalHost(hostname) {
    const h = hostname.toLowerCase();
    if (h === "localhost" || h === "127.0.0.1" || h === "::1")
        return true;
    if (h.endsWith(".localhost"))
        return true;
    return false;
}
export function isValidIdpIssuer(value) {
    if (!value || typeof value !== "string")
        return false;
    try {
        const url = new URL(value.trim());
        if (!url.hostname)
            return false;
        if (url.search || url.hash)
            return false;
        if (url.protocol === "https:")
            return true;
        if (url.protocol === "http:" && isLocalHost(url.hostname))
            return true;
        return false;
    }
    catch {
        return false;
    }
}
let IsValidIdpIssuerConstraint = class IsValidIdpIssuerConstraint {
    validate(value) {
        return isValidIdpIssuer(value);
    }
    defaultMessage(_args) {
        return `Each IdP issuer must be a ${IDP_ISSUER_REQUIREMENTS}`;
    }
};
IsValidIdpIssuerConstraint = __decorate([
    ValidatorConstraint({ name: "IsValidIdpIssuer", async: false })
], IsValidIdpIssuerConstraint);
export { IsValidIdpIssuerConstraint };
